import { omit } from 'lodash';
import * as yup from 'yup';
import { validatePerson } from '../../../../utils/validation/person';
import { validateSwedishSsnFormatting } from '../../../../utils/validation';

export const validationSchema = yup.object().shape({
  ...omit(validatePerson, 'socialSecurityNumber'),

  socialSecurityNumber: yup
    .string()
    .nullable()
    .notRequired()
    .trim()
    .test('ssn formatting', validateSwedishSsnFormatting[1], (value) => {
      if (!value) {
        return true;
      }

      return value.length === 11;
    }),

  email: yup
    .string()
    .trim()
    .email('E-postadressen är felaktig')
    .required('E-postadress krävs'),

  emailRepeat: yup.string().when('email', {
    is: (val) => val.length > 0,
    then: yup
      .string()
      .trim()
      .oneOf([yup.ref('email')], 'E-post måste matcha')
      .required(),
  }),
});
